import React, { useEffect, useState } from "react";

import { Button, Form, Modal, Dropdown } from "react-bootstrap";
import ModalLoader from "../ModalLoader";
import { toast } from "react-toastify";
import { URLS } from "../urls";
import {
  checkStartDate,
  fetchActionsUtil,
  parseDate,
  parseTime,
  useCookie,
  utilGroupBy,
} from "../../utils";
import Cookies from "universal-cookie";
import moment from "moment";
import Papa from "papaparse";
import { CloudIcon, ExcelIcon, ImportIcon, MobileArrowDown } from "../icons";
import { Close } from "@mui/icons-material";
import RsDateRangePicker from "../RsDateRangePicker";

export default function AddAttendanceModal({
  setShowUploadModal,
  showAttendance,
  setshowSaveButton,
  getAttendanceProcessStatus,
  setGroupedAttendance,
}) {
  const cookies = new Cookies();
  const userId = cookies.get("userId");
  const nowDate = new Date();

  const branch_id = useCookie("branch_id");
  const [loading, setLoading] = useState(false);
  const [CheckTotal, setCheckTotal] = useState(0);
  const [permission, setShowPermission] = useState([]);
  const [holiday, setShowHoliday] = useState([]);
  const [rosters, setRosters] = useState([]);

  const [excellDetails, setExcelDetails] = useState([]);
  const [attendanceSetting, setAttendanceSetting] = useState({});
  const [attendanceText, setAttendanceText] = useState("Import Attendance");
  const [allGetDayOff, setAllGetDayOff] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedDates, setSelectedDates] = useState({
    startDate: nowDate,
    endDate: nowDate,
  });

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchData();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const fetchData = async () => {
    try {
      const permissionData = fetchActionsUtil(
        `${URLS.backendpermmission}/by-branch/${branch_id}?status=Approved`
      );

      const attendanceData = fetchActionsUtil(
        `${URLS.backendattendance}/get-settings/${branch_id}`
      );

      const dayOffData = fetchActionsUtil(
        `${URLS.backendDayOff}/by-branch/${branch_id}?status=Approved`
      );

      const employeeData = fetchActionsUtil(
        `${URLS.backendEmployees}/get/${branch_id}`
      );

      const rosterData = fetchActionsUtil(
        `${URLS.backendRosterPlanning}/get/${branch_id}`
      );

      const [
        permissionResult,
        attendanceResult,
        dayOffResult,
        employeeResult,
        rosterResult,
      ] = await Promise.all([
        permissionData,
        attendanceData,
        dayOffData,
        employeeData,
        rosterData,
      ]);

      const holidays = permissionResult?.permission?.filter(
        (el) => el.holidayName !== null && el.holidayName !== undefined
      );
      const permit = permissionResult?.permission?.filter(
        (el) => el.holidayName === null || el.holidayName === undefined
      );

      setShowHoliday(holidays);
      setShowPermission(permit);
      setAttendanceSetting({
        ...attendanceResult.attendance,
      });
      setAllGetDayOff(dayOffResult?.dayOff);
      setEmployees(employeeResult.employees);
      setRosters(rosterResult?.attendance);
    } catch (error) {
      console.log({ error });
    }
  };

  const uploadTimeSheet = (e) => {
    e.preventDefault(e);
    // Group excellDetails by year and month
    // Use a single pass and Map for better performance with large datasets
    const groupedByYearMonthMap = new Map();
    for (let i = 0, len = excellDetails.length; i < len; i++) {
      let item = excellDetails[i];
      let date = item.Date;
      if (!moment.isMoment(date)) {
        date = moment(date, "MM/DD/YYYY");
      }
      const year = date.year();
      const month = date.month() + 1;
      const key = `${year}-${month}`;
      if (!groupedByYearMonthMap.has(key)) {
        groupedByYearMonthMap.set(key, {
          branch_id,
          payrollMonth: month,
          payrollYear: year,
          employeeId: userId,
          excellDetails: [],
          uploadType: attendanceText,
        });
      }
      groupedByYearMonthMap.get(key).excellDetails.push(item);
    }
    const groupedByYearMonthObj = Object.fromEntries(groupedByYearMonthMap);
    // If you need an array of grouped objects:
    const groupedByYearMonthArr = Object.values(groupedByYearMonthObj);

    setGroupedAttendance(groupedByYearMonthArr);
    showAttendance(excellDetails);
    setshowSaveButton(true);
    setShowUploadModal(false);
  };

  const rangeMonthDurations = ({ dates, format }) => {
    // Returns an array of moment dates from startDate to endDate (inclusive)
    const { startDate, endDate } = dates; // expects { startDate, endDate }
    const start = moment(startDate, format);
    const end = moment(endDate, format);
    const days = [];
    let current = start.clone();
    while (current.isSameOrBefore(end, "day")) {
      days.push(current.clone());
      current.add(1, "days");
    }
    return days;
  };

  const checkBetweenDates = ({
    date,
    dateFormat,
    startDateFormat,
    endDateFormat,
    startDate,
    endDate,
    format,
    outFormat,
  }) => {
    return moment(moment(date, dateFormat).format(format), outFormat).isBetween(
      moment(moment(startDate, startDateFormat).format(format), outFormat),
      moment(moment(endDate, endDateFormat).format(format), outFormat),
      null,
      []
    );
  };

  const GeneralPermission = permission.filter((el) => el?.mode === "General");

  const checkForPermission = ({ staffDetails, el, checkType }) => {
    const userPermission = permission.filter(
      (user) => user?.userID?.Staff_ID === staffDetails?.ID
    );

    let absentPermitted = null;

    absentPermitted = userPermission.find(
      (ab) =>
        checkBetweenDates({
          date: el.date,
          dateFormat: "MM/DD/YYYY",
          startDateFormat: "YYYY-MM-DD",
          endDateFormat: "YYYY-MM-DD",
          startDate: ab.startDate,
          endDate: ab.endDate,
          format: "MM/DD/YYYY",
          outFormat: "MM/DD/YYYY",
        }) && ab.type === checkType
    );

    if (!absentPermitted) {
      absentPermitted = GeneralPermission.find(
        (ab) =>
          checkBetweenDates({
            date: el.date,
            dateFormat: "MM/DD/YYYY",
            startDateFormat: "YYYY-MM-DD",
            endDateFormat: "YYYY-MM-DD",
            startDate: ab.startDate,
            endDate: ab.endDate,
            format: "MM/DD/YYYY",
            outFormat: "MM/DD/YYYY",
          }) && ab.type === checkType
      );
    }

    return absentPermitted;
  };

  const checkForHoliday = ({ date }) => {
    const foundHoliday = holiday.find((ab) =>
      checkBetweenDates({
        date,
        dateFormat: "MM/DD/YYYY",
        startDateFormat: "YYYY-MM-DD",
        endDateFormat: "YYYY-MM-DD",
        startDate: ab.startDate,
        endDate: ab.endDate,
        format: "MM/DD/YYYY",
        outFormat: "MM/DD/YYYY",
      })
    );

    return foundHoliday;
  };

  const checkForLeave = ({ staffDetails, el, leave }) => {
    const userLeave = leave?.filter(
      (user) => user?.employee?.id?.Staff_ID === staffDetails?.ID
    );

    const onLeave = userLeave.find((ab) =>
      checkBetweenDates({
        date: el.date,
        dateFormat: "MM/DD/YYYY",
        startDateFormat: "YYYY-MM-DD",
        endDateFormat: "YYYY-MM-DD",
        startDate: new Date(ab.from),
        endDate: new Date(ab.to),
        format: "MM/DD/YYYY",
        outFormat: "MM/DD/YYYY",
      })
    );

    return onLeave;
  };

  const getUserDayOff = (id) => {
    let usersAllowance;

    // Find the selected user
    const user = employees.find((el) => el?.jobInfo?.employeeId === id);
    const jobInfo = user?.jobInfo;

    allGetDayOff.forEach((el) => {
      if (
        el["applySelected"] === "Employees" &&
        el["selectedData"]?.includes(user?.userId)
      ) {
        usersAllowance = { ...el };
      } else if (
        el["applySelected"] === "Job Grade" &&
        el["selectedData"]?.includes(jobInfo?.grade?._id)
      ) {
        usersAllowance = { ...el };
      } else if (el["applySelected"] === "All") {
        usersAllowance = { ...el };
      } else if (
        el["applySelected"] === "Department" &&
        el["selectedData"]?.includes(jobInfo?.department?._id)
      ) {
        usersAllowance = { ...el };
      }
    });

    return usersAllowance;
  };

  const checkDayOff = ({ id, date }) => {
    const user = getUserDayOff(id);

    let dayOffDate = false;

    const foundDate = user?.dateRanges.find((ab) =>
      checkBetweenDates({
        date,
        dateFormat: "YYYY-MM-DD",
        startDateFormat: "YYYY-MM-DD",
        endDateFormat: "YYYY-MM-DD",
        startDate: ab.startDate,
        endDate: ab.endDate,
        format: "MM/DD/YYYY",
        outFormat: "MM/DD/YYYY",
      })
    );

    if (foundDate) {
      dayOffDate = true;
    }

    return dayOffDate;
  };

  const createRosterMap = (rosters) => {
    return rosters.reduce((map, { ID, Date, TimeIn, TimeOut }) => {
      const key = `${ID}_${moment(Date, "YYYY-MM-DD")
        .add(1, "day")
        .format("YYYY-MM-DD")}`;
      map[key] = { TimeIn, TimeOut };
      return map;
    }, {});
  };

  const checkEmployeeRoster = ({
    date,
    staffRecords = {},
    employeeId,
    rosterMap,
  }) => {
    const { in: signIn, out: signOut } = staffRecords;
    const targetKey = `${employeeId}_${moment(date, "M/D/YYYY").format(
      "YYYY-MM-DD"
    )}`;
    const roster = rosterMap[targetKey];

    if (!roster) return false;

    const isEmptyIn = !signIn || signIn === "--";
    const isEmptyOut = !signOut || signOut === "--";

    if (isEmptyIn && isEmptyOut) return "Absent";
    if (isEmptyOut) return "No SignOut";

    const inTime = parseTime(signIn);
    const outTime = parseTime(signOut);
    const refIn = parseTime(roster.TimeIn);
    const refOut = parseTime(roster.TimeOut);

    if (outTime.isBefore(refOut)) return "Early Closure";
    if (refIn.isBefore(inTime)) return "Late";

    return "Good";
  };

  const checkForMoreDetails = ({
    foundDate,
    isLeave,
    members,
    notAStaff,
    staffDetails,
    el,
    dayOffDate,
    isHoliday,
    isRoster,
  }) => {
    const staff = staffDetails[0] || staffDetails;
    const dateMoment = moment(el.date.toString(), "MM/DD/YYYY");

    const pushMember = (data) => members.push(data);

    const defaultStaffObj = (result) => ({
      ...staff,
      in: "--",
      out: "--",
      result,
      Date: dateMoment,
    });

    let weekend = el.day === "Saturday" || el.day === "Sunday";

    if (weekend) {
      weekend = !isRoster;
    }

    const permissionResults = new Set([
      "No SignOut",
      "Late",
      "Early Closure",
      "Absent",
    ]);

    // Helper to check permission and push result accordingly
    const checkAndPushPermission = (foundDateObj, checkType) => {
      const type = checkType === "Late" ? "Lateness" : checkType;
      if (checkForPermission({ staffDetails: staff, el, checkType: type })) {
        pushMember({ ...foundDateObj, result: "Permitted" });
      } else if (type === "Absent" && weekend) {
        pushMember(defaultStaffObj("Weekend"));
      } else {
        pushMember({ ...foundDateObj });
      }
    };
    // console.log({ isRoster, date: el?.date });

    if (foundDate) {
      if (isRoster) {
        pushMember({ ...foundDate, result: isRoster });
      } else if (isHoliday) {
        pushMember({
          ...foundDate,
          result: isHoliday.holidayName || "Holiday",
        });
      } else if (isLeave) {
        pushMember({
          ...foundDate,
          result: `${isLeave?.name?.split(" ")[0]} Leave` || "OnLeave",
        });
      } else if (notAStaff) {
        pushMember(defaultStaffObj("Not a staff"));
      } else if (dayOffDate) {
        pushMember(defaultStaffObj("Day Off"));
      } else if (permissionResults.has(foundDate.result)) {
        checkAndPushPermission(foundDate, foundDate.result.replace(/\s+/g, ""));
      } else {
        pushMember({ ...foundDate });
      }
    } else {
      if (weekend) {
        pushMember(defaultStaffObj("Weekend"));
      } else if (isHoliday) {
        pushMember(defaultStaffObj(isHoliday.holidayName || "Holiday"));
      } else if (isLeave) {
        pushMember(
          defaultStaffObj(`${isLeave?.name?.split(" ")[0]} Leave` || "OnLeave")
        );
      } else if (notAStaff) {
        pushMember(defaultStaffObj("Not a staff"));
      } else if (dayOffDate) {
        pushMember(defaultStaffObj("Day Off"));
      } else {
        const permitted = checkForPermission({
          staffDetails: staff,
          el,
          checkType: "Absent",
        });
        pushMember(defaultStaffObj(permitted ? "Permitted" : "Absent"));
      }
    }
  };

  const classifyAttendance = (entries) => {
    if (!entries?.length) return null;

    const [first, second] = entries.sort(
      (a, b) => parseTime(a.Time) - parseTime(b.Time)
    );
    const isEmptyIn = !first?.Time;
    const isEmptyOut = !second?.Time;
    const DateObj = parseDate(first?.Date);
    const Name = first?.User;
    const ID = first?.WorkId;
    const startDate = first?.startDate;
    const rosterWork = first?.rosterWork;

    const inTime = parseTime(first?.Time);
    const outTime = parseTime(second?.Time);
    const timeInRef = parseTime(attendanceSetting?.resumeTime);
    const timeOutRef = parseTime(attendanceSetting?.closingTime);

    let result;
    if (entries.length === 1) {
      result = isEmptyIn ? "Absent" : "No SignOut";
    } else if (isEmptyIn && isEmptyOut) {
      result = "Absent";
    } else if (outTime.isBefore(timeOutRef)) {
      result = "Early Closure";
    } else if (timeInRef.isBefore(inTime)) {
      result = "Late";
    } else {
      result = "Good";
    }

    return {
      in: first?.Time || "--",
      out: second?.Time || "--",
      Name,
      ID,
      Date: DateObj,
      result,
      startDate,
      rosterWork,
    };
  };

  const manipulateUserAttendanceData = ({ staffForMonths, leave }) => {
    const curDate = rangeMonthDurations({
      dates: { ...selectedDates },
      format: "MM/DD/YYYY",
    }).map((d) => ({ date: d.format("M/D/YYYY"), day: d.format("dddd") }));

    const staffGrouped = utilGroupBy(staffForMonths, "WorkId");

    const attendanceData = Object.entries(staffGrouped).map(
      ([workId, records]) => {
        const recordsByDate = utilGroupBy(records, "Date");
        return Object.entries(recordsByDate).map(([date, entries]) =>
          classifyAttendance(entries)
        );
      }
    );

    const members = [];

    for (const day of curDate) {
      for (const staffRecords of attendanceData) {
        const record = staffRecords.find(
          (r) => r.Date?.format("M/D/YYYY") === day.date
        );
        const sample = staffRecords[0];
        const formattedDate = moment(day.date, "MM/DD/YYYY").format(
          "YYYY-MM-DD"
        );
        const formattedDDMMYYYY = moment(day.date, "MM/DD/YYYY").format(
          "DD/MM/YYYY"
        );

        const isLeave = checkForLeave({ staffDetails: sample, el: day, leave });

        const notAStaff = checkStartDate({
          date: formattedDDMMYYYY,
          startDate: sample?.startDate,
        });
        const dayOffDate = checkDayOff({ id: sample?.ID, date: formattedDate });
        const isHoliday = checkForHoliday({ date: day.date });

        const rosterMap = createRosterMap(rosters);

        const isRoster = checkEmployeeRoster({
          date: day.date,
          staffRecords: record,
          employeeId: sample?.ID,
          rosterMap,
        });

        checkForMoreDetails({
          foundDate: record,
          isLeave,
          members,
          notAStaff,
          staffDetails: sample,
          el: day,
          dayOffDate,
          isHoliday,
          isRoster,
        });
      }
    }

    setCheckTotal(members.length);
    setExcelDetails(members);
    setLoading(false);
  };

  // Read attendance from excel
  function handleFile({ eventData: e }) {
    setLoading(true);

    const file = e?.target?.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = async function ({ target }) {
        try {
          const startDate = moment(
            selectedDates.startDate,
            "MM/DD/YYYY"
          ).format("YYYY-MM-DD");
          const endDate = moment(selectedDates.endDate, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          );

          const { leave } = await fetchActionsUtil(
            `${URLS.backendApplyLeaves}/dynamic-by-months/${branch_id}?startDate=${startDate}&endDate=${endDate}`
          );

          const { employees } = await fetchActionsUtil(
            `${URLS.backendEmployees}/get/${branch_id}`
          );

          const parsedData = [];
          Papa.parse(target?.result, {
            header: true,
            step: function (row) {
              parsedData.push(row.data);
            },
            complete: function () {
              const workIdSet = new Set(employees?.map((el) => el?.Staff_ID));
              const start = moment(selectedDates.startDate, "MM/DD/YYYY");
              const end = moment(selectedDates.endDate, "MM/DD/YYYY");

              const dateKeyMap = new Map();

              for (const el of parsedData) {
                if (!workIdSet.has(el.WorkId)) continue;

                const date = moment(el.Date, "MM/DD/YYYY");
                if (!date.isBetween(start, end, undefined, "[]")) continue;

                const key = `${el.WorkId}-${el.Date}`;
                if (!dateKeyMap.has(key)) dateKeyMap.set(key, []);
                dateKeyMap.get(key).push(el);
              }

              const allEmployees = [];

              for (const [key, entries] of dateKeyMap.entries()) {
                const sorted = entries.sort(
                  (a, b) =>
                    moment(a.Time, "HH:mm").valueOf() -
                    moment(b.Time, "HH:mm").valueOf()
                );

                const endpoints = [sorted[0]];
                if (sorted.length > 1)
                  endpoints.push(sorted[sorted.length - 1]);

                for (const item of endpoints) {
                  const user = employees?.find(
                    (em) => em.Staff_ID === item.WorkId
                  );
                  const startDate = user?.jobInfo?.startDate;
                  const nameInfo = user?.personalInfo?.name || {};
                  const name = `${nameInfo.first || ""} ${
                    nameInfo.middle || ""
                  } ${nameInfo.last || ""}`.trim();

                  allEmployees.push({
                    ...item,
                    User: name,
                    startDate,
                  });
                }
              }

              manipulateUserAttendanceData({
                staffForMonths: allEmployees,
                leave,
              });
            },
          });
        } catch (err) {
          console.log(err);
        }
      };
      reader.readAsText(file);
      e.target.value = "";
    }
  }

  // Get attendance from database
  const getFromInvexAndMobile = async ({ mobile }) => {
    setLoading(true);

    let startDate = moment(selectedDates.startDate, "MM/DD/YYYY").format(
      "YYYY/MM/DD"
    );
    let endDate = moment(selectedDates.endDate, "MM/DD/YYYY").format(
      "YYYY/MM/DD"
    );

    if (mobile) {
      const data = await fetchActionsUtil(
        `${URLS.backendattendance}/log?startDate=${startDate}&endDate=${endDate}&branch_id=${branch_id}`
      );

      if (data?.success) {
        // sessionStorage.setItem("checkAttendanceStatusInterval", "true");
        getAttendanceProcessStatus();
        toast.success(data?.message);
      } else if (!data?.success && data?.message) {
        toast.error(data?.message);
      }
      setLoading(false);
      setShowUploadModal(false);
    } else {
      const data = await fetchActionsUtil(
        `${URLS.mainSiteBackend}/users/attendance/log?startDate=${startDate}&endDate=${endDate}`
      );

      let attendace = data?.attendace;

      const { employees } = await fetchActionsUtil(
        `${URLS.backendEmployees}/get/${branch_id}`
      );

      startDate = moment(startDate, "YYYY/MM/DD").format("YYYY-MM-DD");
      endDate = moment(endDate, "YYYY/MM/DD").format("YYYY-MM-DD");

      const { leave } = await fetchActionsUtil(
        `${URLS.backendApplyLeaves}/dynamic-by-months/${branch_id}?startDate=${startDate}&endDate=${endDate}`
      );

      const umquiIds = [
        ...new Set(
          attendace?.map((el) => `${el.Employee_ID}-${el.Access_Date}`)
        ),
      ];

      const cleanedData = umquiIds
        .map((el) => {
          const uniqueEmployees = attendace
            ?.filter((ft) => el === `${ft.Employee_ID}-${ft.Access_Date}`)
            // .sort((p1, p2) => (p1.id < p2.id ? -1 : p1.id > p2.id ? 1 : 0))
            .sort(
              (a, b) =>
                moment(a.Access_Date_and_Time, "YYYY-MM-DD HH:mm").format(
                  "HH:mm"
                ) -
                moment(b.Access_Date_and_Time, "YYYY-MM-DD HH:mm").format(
                  "HH:mm"
                )
            )
            .filter((ele, i, arr) => i === 0 || i === arr.length - 1)
            .map((ele) => {
              const user = employees?.find(
                (em) => em.Staff_ID === ele?.Employee_ID
              );
              const userName = user?.personalInfo?.name;
              const startDate = user?.jobInfo?.startDate;

              const name = `${userName?.first ? userName?.first : ""} ${
                userName?.middle ? userName?.middle : ""
              } ${userName?.last ? userName?.last : ""}`;

              return {
                User: name,
                WorkId: ele?.Employee_ID,
                CardNo: "NULL",
                Date: moment(ele?.Access_Date, "YYYY-MM-DD").format(
                  "MM/DD/YYYY"
                ),
                Time: moment(
                  ele?.Access_Date_and_Time,
                  "YYYY-MM-DD HH:mm"
                ).format("H:mm"),
                "IN/OUT": "IN",
                EventCode: "30038",
                startDate,
              };
            });

          return uniqueEmployees;
        })
        .flat(1);
      manipulateUserAttendanceData({ staffForMonths: cleanedData, leave });
    }
  };

  const cancelRequest = (e) => {
    e.preventDefault(e);
    setSelectedDates({
      startDate: nowDate,
      endDate: nowDate,
    });
    setExcelDetails([]);
    setAttendanceText("Import Attendance");
    setCheckTotal(0);
  };

  const filterByDateRange = (event, picker) => {
    setSelectedDates({
      startDate: picker.startDate.format("MM/DD/YYYY"),
      endDate: picker.endDate.format("MM/DD/YYYY"),
    });
    picker.element.value = `${picker.startDate.format(
      "MM/DD/YYYY"
    )} - ${picker.endDate.format("MM/DD/YYYY")}`;
  };

  const clearDateRange = (event, picker) => {
    setSelectedDates({
      startDate: nowDate,
      endDate: nowDate,
    });

    picker.element.value = "";
  };

  return (
    <>
      <Modal
        className="custom-modal"
        show={true}
        centered
        onHide={() => {
          setShowUploadModal(false);
        }}
      >
        <Form className="">
          {/* <Modal.Header>
            <Modal.Title>Import Attendance</Modal.Title>
          </Modal.Header> */}
          <div className="d-flex align-items-center px-5 pt-5 justify-content-between gap-4">
            <h5 className="page-title page-title-alt m-0 p-0">
              Import Attendance
            </h5>
            <div
              className="btn-close-alt"
              onClick={() => {
                setShowUploadModal(false);
              }}
            >
              <Close />
            </div>
          </div>
          <Modal.Body>
            <input name="employeeId" type="hidden" value={userId} />
            <input name="branch_id" type="hidden" value={branch_id} />

            <div className="my-4">
              <label className="ml-2 text-16 font-600  light-text mb-2">
                Select your range
              </label>
              <RsDateRangePicker
                placement="topEnd"
                className="form-control-w-0 w-100"
                onClean={(event, picker) => clearDateRange(event, picker)}
                onOk={(event, picker) => filterByDateRange(event, picker)}
              />
            </div>

            <div className="w-full d-flex mr-2 ml-2 mt-4 align-items-center justify-content-between">
              <Dropdown className="d-flex  align-items-center gap-3 ">
                <Dropdown.Toggle variant="primary" bsPrefix="">
                  <ImportIcon color="#fff" /> {attendanceText}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{
                    strategy: "fixed",
                  }}
                  renderOnMount
                  className=""
                >
                  <Dropdown.Item as="label" className="p-cursor" title="Import">
                    <input
                      type="file"
                      className="d-none"
                      onChange={(e) => {
                        handleFile({
                          eventData: e,
                        });
                        setAttendanceText("Attendance From Excel");
                      }}
                      accept=".csv"
                    />
                    <ExcelIcon color="#008000" />{" "}
                    <span className="mx-2">Upload from Excel</span>
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    as="div"
                    onClick={() => {
                      getFromInvexAndMobile({ mobile: false });
                      setAttendanceText("Attendance From Cloud");
                    }}
                    className="p-cursor"
                  >
                    <CloudIcon color="#2463ae" />{" "}
                    <span className="mx-2">Upload from Cloud</span>
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    as="div"
                    onClick={() => {
                      getFromInvexAndMobile({ mobile: true });
                      setAttendanceText("Attendance From Remote Devices");
                    }}
                    className="p-cursor"
                  >
                    <MobileArrowDown color="#2463ae" />{" "}
                    <span className="mx-2"> Upload from Remote Devices</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="dark-text fw-bold ">
                <p>{`${CheckTotal} Rows`}</p>
              </div>
            </div>
            <hr />
            <div className="d-flex align-items-center gap-4 ml-2 mt-6">
              {excellDetails.length > 0 && (
                <Button onClick={(e) => uploadTimeSheet(e)}>View</Button>
              )}

              <button
                className="btn btn-secondary btn-secondary-alt"
                onClick={(e) => cancelRequest(e)}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer className="text-left"></Modal.Footer>
        </Form>
      </Modal>
      <ModalLoader show={loading} />
    </>
  );
}
